import React, { useState } from "react";
import { postCompliance, patchCompliance } from "@/api/compliances";

export default function ComplianceForm({ compliance = null, onSave }) {
    const [name, setName] = useState(compliance?.name || "");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        const payload = { name };

        const result = compliance?.id
            ? await patchCompliance(compliance.id, payload)
            : await postCompliance(payload);

        if (result) {
            onSave?.(result);
        } else {
            setError("Something went wrong.");
        }

        setLoading(false);
    };

    return (
        <form onSubmit={handleSubmit} className="space-y-4">
            {error && <p className="text-sm text-red-600">{error}</p>}

            <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                <input
                    type="text"
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                />
            </div>

            <button
                type="submit"
                disabled={loading}
                className="bg-[#5D1F42] text-white text-sm px-4 py-2 rounded-lg hover:bg-[#712a55] transition"
            >
                {loading ? "Saving..." : compliance ? "Update" : "Create"}
            </button>
        </form>
    );
}
